import { render, staticRenderFns } from "./RpdVerdictBand.vue?vue&type=template&id=26b39bb9"
import script from "./RpdVerdictBand.vue?vue&type=script&lang=js"
export * from "./RpdVerdictBand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports